module.exports = __webpack_public_path__ + "static/media/csr_health.a86271b9.JPG";